<template>
  <div
    class="c-form-factor-filter l-grid"
  >
    <ring-width
      v-for="width in widths"
      :key="width"
      :width="width"
      :active="isEnabled(width) ? width : null"
      role="checkbox"
      :aria-checked="isEnabled(width) ? true : false"
      class="c-form-factor-filter__ring-width"
      @click.native="toggleFilter(width)"
    />
  </div>
</template>
<script>
import FilterMixin from '@/mixins/filter'
import RingWidth from '../ringWidth/RingWidth'
export default {
  components: {
    RingWidth
  },
  mixins: [
    FilterMixin
  ],
  computed: {
    widths() {
      const values = this.values
      const widthOrder = [
        'Wide',
        'Standard',
        'Thin',
        'Halo',
        'Stackable'
      ]
      let result = []
      for (let width of widthOrder) {
        if (values.includes(width)) {
          result.push(width)
        }
      }
      return result
    }
  }
}
</script>
<style lang="scss" scoped>
.c-form-factor-filter {
  width: 100%;
  grid-template-columns: repeat(5, 1fr);
  @include respond(phone) {
      grid-template-columns: repeat(4, 1fr);
    }
  gap: 30px;
  grid-auto-rows: minmax(rem(40px), auto);
  &__ring-width {
    cursor: pointer;
  }
}
</style>
